import { useSelector } from "react-redux";
import TransactionReport from "../../CommonViewPages/TransactionReport.js";

const AdminTransactionReport = () => {
  const { userDetails } = useSelector((state) => state.user);

  return <TransactionReport userDetails={userDetails} />;
};

export default AdminTransactionReport; 